import { useContext } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import useDropdown from '../../../../lib/hooks/useDropdown';
import Text from '../../../Text';
import { InteractionContext } from '../../contexts';
import { MULTIPLE_CHOICE } from '../../utils/constants';
import defaultAttrs from '../../../../lib/utils/defaultAttrs';

const InteractionType = ({ text, id, options }) => {
  const {
    buttonRef,
    dropdownRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();

  const { handleQuestionSubTypeOnChange, values } = useContext(
    InteractionContext,
  );

  const isSelectedDropdown = value => {
    if (value === MULTIPLE_CHOICE) {
      return values.questionType === id && values.questionSubtype === value;
    }

    return values.questionSubtype === value;
  };

  return (
    <InteractionTypeWrapper
      ref={buttonRef}
      onClick={() => setShowDropdown(state => !state)}
    >
      <InteractionTypeButton isSelected={values.questionType === id}>
        {text} <i className="fa-solid fa-caret-down"></i>
      </InteractionTypeButton>

      {showDropdown && (
        <Dropdown ref={dropdownRef}>
          {options.map(({ name, value }) => (
            <DropdownItem
              key={value}
              onClick={() => {
                handleQuestionSubTypeOnChange(id, value);
              }}
              isSelected={isSelectedDropdown(value)}
            >
              {name}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </InteractionTypeWrapper>
  );
};

export default InteractionType;

const InteractionTypeWrapper = styled.li`
  width: 100%;
  text-align: center;
  border: 1px solid ${themeGet('colors.black.10')};
  &:first-child {
    border-radius: 8px 0 0 8px;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

const InteractionTypeButton = styled(Text).attrs(
  defaultAttrs({
    as: 'button',
    type: 'button',
    variant: 'body1',
  }),
)`
  width: 100%;
  background: transparent;
  border: 0px;
  margin-bottom: 3px;
  height: 43px;
  padding-right: 20px;
  color: ${({ isSelected }) =>
    isSelected ? themeGet('colors.primary.100') : themeGet('colors.black.80')};

  &:hover,
  &:focus {
    background: transparent;
    color: ${({ isSelected }) =>
      isSelected
        ? themeGet('colors.primary.100')
        : themeGet('colors.black.60')};
  }
`;

const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.white')};
  z-index: 10;
  width: 25%;
  margin: 8px 0 0 0;
  text-align: left;
  position: absolute;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.24);
  border-radius: 8px;
`;

const DropdownItem = styled(Text)`
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  font-size: 14px;
  line-height: 2.5em;
  margin: 0;
  padding: 5px 10px;
  color: ${({ isSelected }) =>
    isSelected ? themeGet('colors.primary.100') : themeGet('colors.black.80')};

  &:hover {
    background-color: ${themeGet('colors.black.5')};
  }
`;
